// 定义英文语言包对象
export default {
	"lang": {
		"back": "Back",
		"save": "Save",
		"do": "Action",
		"select": "Query",
		"add": "Add",
		"status": "Status",
		confirm:"Confirm",
		"cancel": "Cancel",
		"selectAll": "Select All",
		"description": "Description",
		"getLocation": "Get Coords",
		"theme": {
			"tip": "Theme",
			"light": "Light",
			"dark": "Dark",
			"orange": "Orange"
		},
		"date": {
			"month": "Month",
			"week": "Week",
			"day": "Day",
			"year": "Year",
			"unit": "Per",
			"hour": "Hour",
			"hourUnit": "o'clock",
			"second": "Second",
			"millisecond": "Millisecond",
			"startTime": "Start Date",
			"endTime": "End Date",
			"loadHour": "Hourly",
			"loadDay": "Daily",
			"createTime": "Created"
		},
		"device": {
			"add": "New",
			"edit": "Edit",
			"search": "Search",
			"del": "Delete",
			"count": "Total",
			"deviceTypeTitle": "Device Type",
			"deviceGroupTitle": "Device Group",
			"deviceModelTitle": "Device Model",
			"detail": "Details",
			"deviceInformation": "Device Info",
			"actions": "Points Table",
			"deviceName": "Name",
			"deviceNo": "Code",
			"deviceDescription": "Description",
			"deviceId": "Terminal ID",
			"status": "Active Status",
			"ver": "Protocol Ver",
			"deviceData": "Realtime Data",
			"selectDeviceData": "Query Params",
			"deviceHistoryHour": "Hourly History",
			"deviceHistoryday": "Daily History",
			"deviceHistoryMonth": "Monthly History",
			"activeTime": "Comm Time",
			"null": "No Data",
			"deviceUnit": "units",
			"dtuId": "Uplink Relay",
			"modbusSlaveNo": "Slave No",
			"deviceEdit": {
				"deviceProp": "Properties",
				"deviceId": "Device ID",
				"protocolVersion": "Protocol Ver",
				"factoryModelName": "Original Model",
				"udpPort": "Service Port",
				"dtuDeviceId": "Uplink Relay",
				"modbusSlaveNo": "Slave No",
				"potentialTransformer": "Voltage Ratio",
				"currentTransformer": "Current Ratio",
				"intervalMonitor": "Monitor Cycle",
				"comProtocol": "Comm Protocol",
				"serialPortName": "Serial Port",
				"baudRate": "Baud Rate",
				"dataBit": "Data Bits",
				"stopBit": "Stop Bits",
				"parityCheck": "Parity",
				"frameCheck": "Frame Check",
				"broadcastEnable": "Listen Broadcast",
				"serverAddress": "Comm Address",
				"serverPort": "Service Port",
				"chargeAmuDeviceId": "Charge AMU",
				"dischargeAmuDeviceId": "Discharge AMU",
				"coa": "Common Address",
				"interrogationType": "Interrogation Type",
				"useMultiThreads": "Use Multi-thread",
				"pauseTime": "Interval",
				"cicnaFrequency": "General Call Freq",
				"bcpDeviceId": "Battery Cabin",
				"bcpStackDeviceId": "Battery Stack"
			},
			"prop": {
				"title": "Config",
				"save": "Save Config",
				"bizAction": "Capabilities",
				"amu": {
					"title": "AMU Config",
					"currentTransformer": "Current Ratio",
					"potentialTransformer": "Voltage Ratio",
					"ratedPowerCapacity": "Rated Capacity",
					"maxDemandActivePower": "Max Demand Power",
					"maxDemandActivePowerTip": "Set to 1 for capacity billing, 0 for demand billing.",
					"preservedActivePowerCharge": "Reserved Charge Power",
					"protectionActivePower": "Discharge Protect Power",
					"broadcastEnable": "Charge/Discharge Priority",
					"prohibitSimultaneousChargingAndDischarging": "No Simultaneous C/D",
					"priorityCharging": "Priority Charge",
					"preferentialDischarge": "Priority Discharge"
				},
				"esc": {
					"title": "ESC Config",
					"maxActivePowerCharge": "Max Charge Power",
					"minActivePowerCharge": "Min Charge Power",
					"maxActivePowerDischarge": "Max Discharge Power",
					"minActivePowerDischarge": "Min Discharge Power",
					"maxSoc": "SOC Max",
					"minSocGridOn": "Grid-On SOC Min",
					"minSocGridOff": "Grid-Off SOC Min",
					"minSoh": "SOH Min",
					"reactivePowerCharge": "Charge Reactive Pwr",
					"reactivePowerDischarge": "Discharge Reactive Pwr",
					"maxDurationStandby": "Max Standby Time",
					"standbyAfterDisconnecting": "Auto Standby Time",
					"standbyAfterDisconnectingTip": "0 or -1: Disabled. Default: -1.",
					"maxEnvTemperature": "Env Temp Max",
					"minEnvTemperature": "Env Temp Min",
					"maxEnvHumidity": "Env Humidity Max",
					"minEnvHumidity": "Env Humidity Min",
					"maxPcsCoolerTemperature": "PCS Cooler Max Temp",
					"maxBmsCellTemperature": "Cell Temp Max",
					"minBmsCellTemperature": "Cell Temp Min",
					"maxAverageBmsCellTemperature": "Avg Cell Temp Max",
					"minGridFrequency": "Grid Freq Min",
					"minGridFrequencyTip": "Unit: 0.001Hz. Range: 49500-50500. Default: 49500.",
					"maxGridFrequency": "Grid Freq Max",
					"maxGridFrequencyTip": "Unit: 0.001Hz. Range: 49500-50500. Default: 50500."
				},
				"modeBus": {
					"setDeviceProp": "Set Capabilities",
					"addDeviceProp": "Add Capability",
					"isDel": "Delete this register?",
					"registerStart": "Start Addr",
					"registerLength": "Length",
					"slaveNo": "Slave No",
					"opCode": "Func Code",
					"bizAction": "Capability",
					"readStatus": "Read Params",
					"opCodeType": {
						"readHoldingRegister": "Read Holding Reg(0x03)",
						"readInputRegister": "Read Input Reg(0x04)",
						"writeToHoldRegister": "Write Hold Reg(0x06)"
					}
				},
				"iec104": {
					"title": "Info Points",
					"setDeviceProp": "Set Capabilities",
					"addDeviceProp": "Add Capability",
					"isDel": "Delete this point?",
					"coa": "Common Addr",
					"ioa": "Info Addr",
					"dataType": "Data Type",
					"bizAction": "Capability",
					"generalInterrogation": "General Call",
					"singleInterrogation": "Single Call",
					"groupInterrogation": "Group Call",
					"mixedMode": "Mixed Mode",
					"yes": "Yes",
					"no": "No",
					"strange": "Odd",
					"occasionally": "Even",
					"None": "None",
					"iec104DataType": {
						"M_SP_NA_1": "Single Point",
						"M_SP_TB_1": "SP with Time",
						"M_DP_NA_1": "Double Point",
						"M_DP_TB_1": "DP with Time",
						"M_ME_NA_1": "Normalized",
						"M_ME_TD_1": "Normalized w/Time",
						"M_ME_NB_1": "Scaled",
						"M_ME_TE_1": "Scaled w/Time",
						"M_ME_NC_1": "Short Float",
						"M_ME_TF_1": "Float w/Time"
					}
				}
			},
			"deviceType": {
				"name": "Type Name",
				"no": "Type Code",
				"description": "Description"
			},
			"deviceFactory": {
				"name": "Factory Name",
				"no": "Factory Code",
				"description": "Description"
			},
			"deviceModel": {
				"name": "Model Name",
				"no": "Model Code",
				"description": "Description"
			},
			"status": {
				"title": "Status",
				"active": "Normal",
				"error": "Fault",
				"alarm": "Doubt",
				"unRegister": "Unregistered",
				"register": "Registered",
				"cancelRegister": "Unregister",
				"disabled": "Disabled"
			},
			"event": {
				"title": "Events",
				"null": "No Events"
			},
			"whm": {
				"title": "Meter Details",
				"stationId": "Slave No",
				"potentialTransformer": "Voltage Ratio",
				"currentTransformer": "Current Ratio",
				"current": "Current",
				"currentA": "Phase A Current",
				"currentB": "Phase B Current",
				"currentC": "Phase C Current",
				"voltage": "Voltage",
				"voltageA": "Phase A Voltage",
				"voltageB": "Phase B Voltage",
				"voltageC": "Phase C Voltage",
				"addTodayData": "Today Incr",
				"positiveActiveEnergy": "Forward Energy",
				"negativeActiveEnergy": "Reverse Energy",
				"total": "Total",
				"tsim": "Peak",
				"peak": "Peak",
				"flat": "Flat",
				"valley": "Valley",
				"powerFactor": "Power Factor"
			},
			"pvi": {
				"outputPower": "Output Power",
				"todatQuantity": "Generation",
				"pviWorkStatus": "Inverter Status",
				"pviChart": "Energy Flow",
				"queryStatus": "Query Params",
				"todayEngry": "Today Gen",
				"event": "Events",
				"control": "Control",
				"setOutputPowerPercent": "Set Power %",
				"outputPowerPercent": "Power %",
				"setControlFactor": "Set PF",
				"controlFactor": "Power Factor",
				"open": "Start",
				"close": "Stop",
				"data": "Data",
				"history": "History",
				"status": {
					"standby": "Standby",
					"work": "Working",
					"null": "Unknown",
					"current": "Current",
					"currentA": "Phase A Current",
					"currentB": "Phase B Current",
					"currentC": "Phase C Current",
					"voltage": "Voltage",
					"voltageA": "Phase A Voltage",
					"voltageB": "Phase B Voltage",
					"voltageC": "Phase C Voltage",
					"power": "Power",
					"powerRatio": "Power Ratio",
					"powerFactor": "Power Factor",
					"env": "Environment",
					"temperature": "Temp",
					"engry": "Generation",
					"totalEngry": "Total Gen",
					"todayEngry": "Today Gen"
				}
			}
		},
		"envData": {
			"title": "Env Contribution",
			"treesaving": "Equivalent Trees",
			"energysaving": "Energy Saved",
			"cosaving": "CO₂ Reduced",
			"treeUnit": "trees",
			"tin": "t"
		},
		"logintab": {
			"text": "HLY Smart Energy System",
			"untip": "Username",
			"pwtip": "Password",
			"identify": "Verification Code",
			"nullParmter": "Enter username & password",
			copyrightDate: "江苏合力四通智能科技股份有限公司 © 2025",
			copyrightText:"备案号：",
			companyPhone:"咨询热线：0511-85336035",
			companyEmail:"邮箱：admin@helist.com.cn",
			companyAddres:"地址：江苏省镇江市新区丁卯扬帆路10号",
			bottomtip3:"技术支持：江苏合力四通",
			"logintext": "Login"
		},
		"notify": {
			"notify": "Notification",
			"title": "Prompt",
			"reslut": "Result",
			"nullParmter": "Required param missing",
			"delText": "Irreversible. Continue?"
		},
		"user": {
			"changepw": "Change Password",
			"exit": "Logout",
			"newPassword": "New Password",
			"confirmPassword": "Confirm"
		},
		"notFind": {
			"title": "404",
			"text": "Page not found",
			"nullParmter": "Enter username & code"
		},
		"mainView": {
			"emptyTip": "No Data",
			"runInformation": {
				"title": "Device Operation"
			},
			"deviceManage": {
				"title": "Maintenance",
				"month": "Month",
				"day": "Day",
				"year": "Year",
				"repair": {
					"finish": "Repaired",
					"noFinish": "Pending"
				},
				"check": {
					"finish": "Inspected",
					"noFinish": "Pending"
				}
			},
			"envData": {
				"title": "Env Contribution"
			},
			"loadphotovoltaic": {
				"title": "PV Analysis",
				"key": "PV",
				"charger": "Generation",
				"disCharger": "Feed-in"
			},
			"loadEnergy": {
				"title": "ESS Analysis",
				"key": "ESS",
				"charger": "Charge",
				"disCharger": "Discharge"
			},
			"newestOrder": {
				"title": "Latest Orders",
				"null": "No Orders"
			},
			"alarmMessage": {
				"title": "Project Events",
				"null": "No Alarms"
			},
			"alarmTop": {
				"title": "Monthly Alarm Rank",
				"null": "No Data"
			}
		},
		"menuContainer": {
			"topMenu": {
				"logotext": "Smart Energy Control"
			}
		},
		"projectMonitor": {
			"select": {
				"deviceType": "Filter Type",
				"deviceGroup": "Filter Group",
				"deviceModel": "Filter Model",
				"searchKey": "Keyword"
			}
		},
		"subarea": {
			"deviceArea": {
				"placeholder": "Area Name",
				"add": "New Area",
				"edit": "Edit Area",
				"delTip": "Delete this area?",
				"areaName": "Name",
				"areaNo": "Code",
				"areaAddres": "Address",
				"areaLocation": "Location",
				"createTime": "Created",
				"areaDescription": "Description",
				"areaDo": "Actions",
				"city": "City"
			},
			"deviceGroup": {
				"placeholder": "Group Name",
				"delTip": "Delete this group?",
				"add": "New Group",
				"edit": "Edit Group",
				"groupName": "Name",
				"groupNo": "Code",
				"groupAddres": "Address",
				"groupLocation": "Location",
				"createTime": "Created",
				"groupDescription": "Description",
				"groupDo": "Actions",
				"gourpStatus": "Status",
				"area": "Area"
			}
		},
		"createDevice": {
			"next": "Next",
			"back": "Back"
		},
		"log": {
			"manage": {
				"title": "Manage Logs"
			},
			"operationLogs": {
				"title": "Operation Logs"
			},
			"visithistories": {
				"title": "Access Logs"
			},
			"userActivityLog": {
				"title": "User Logs"
			}
		},
		"project": {
			"projectName": "Project Name",
			"projectNo": "Project Code",
			"city": "City",
			"location": "Location",
			"createTime": "Created",
			"role": {
				"title": "Role Info",
				"roleName": "Role Name",
				"roleNo": "Role Code",
				"project": "Project",
				"device": {
					"deviceManage": "Device Mgmt",
					"deviceFactory": "Manufacturer",
					"deviceModel": "Model",
					"deviceArea": "Area",
					"deviceGroup": "Group",
					"deviceList": "Devices"
				},
				"analysisAndOrder": {
					"analysisAndOrderLabel": "Analysis & Report",
					"historyAnalysis": "Efficiency Analysis"
				},
				"log": {
					"title": "Log Audit"
				},
				"authValue": {
					"null": "N/A",
					"Audit": "Audit",
					"Browse": "Browse",
					"edit": "Edit"
				}
			},
			"member": {
				"userName": "Username",
				"passwd": "Password",
				"phone": "Phone",
				"realName": "Real Name",
				"userRole": "Role",
				"project": "Project",
				"loginTime": "Login Time"
			}
		},
		"projectSource": {
			"saveParam": "Save Params",
			"nullParam": "No changes",
			"languagePlaceholder": "Select Language",
			"message": {
				"general": {
					"title": "General",
					"zone": "Time Zone",
					"zoneTip": "Project time zone. Range: -12 - 12."
				},
				"webParams": {
					"general": {
						"CommonOnceLoadRows": "Load Rows",
						"CommonOnceLoadRowsTip": "Default: 25.",
						"HttpRequestTimeout": "HTTP Req Timeout",
						"HttpRequestTimeoutTip": "Seconds. Range: 5-180.",
						"HttpConnectTimeout": "HTTP Conn Timeout",
						"HttpConnectTimeoutTip": "Seconds. Range: 5-180.",
						"CommonOnceLoadHistoryRows": "Load Log Rows",
						"CommonOnceLoadHistoryRowsTip": "Default: 50.",
						"SystemTimezone": "DB Timezone",
						"SystemTimezoneTip": "Range: -12 - 12.",
						"HttpSocketTimeout": "HTTP Read Timeout",
						"HttpSocketTimeoutTip": "Seconds. Range: 5-180."
					},
					"message": {
						"SystemMessageAdmin": "Sys Msg User",
						"SystemMessageAdminTip": "Source user for system messages.",
						"MailServerAddress": "SMTP Server",
						"MailServerSmtpPort": "SMTP Port",
						"MailServerSmtpsPort": "SMTP SSL Port",
						"MailSmtpValidate": "SMTP Auth",
						"MailSmtpValidateTip": "Require authentication.",
						"MailSender": "Admin Email",
						"MailSenderTip": "Sender email address.",
						"MailSenderAccount": "Email Account",
						"MailSenderPassword": "Email Auth Code",
						"MailSenderPasswordTip": "Authorization code, not password.",
						"SmsHistoryExpired": "SMS Keep Days",
						"SmsHistoryExpiredTip": "Days to keep SMS records."
					},
					"hly": {
						"BizPressText": "Watermark Text",
						"BizPressTextTip": "Max 10 chars. Empty to disable.",
						"BizCountUploadImages": "Max Upload Images",
						"BizCountUploadImagesTip": "Default: 50, Max: 100.",
						"ProjectScanFrequency": "Task Scan Freq",
						"ProjectScanFrequencyTip": "Seconds. Range: 1-3600. Default: 60.",
						"DeviceHeartBeatFrequencyMin": "Min Heartbeat",
						"DeviceHeartBeatFrequencyMinTip": "Seconds. Default: 180.",
						"DeviceHeartBeatFrequencyMax": "Max Heartbeat",
						"DeviceHeartBeatFrequencyMaxTip": "Seconds. Default: 7200.",
						"DeviceHeartBeatFrequency": "Heartbeat Freq",
						"DeviceHeartBeatFrequencyTip": "Seconds. Default: 300.",
						"DeviceActiveAttemptionTitle": "Heartbeat Retry",
						"DeviceActiveAttemptionTip": "Default: 10.",
						"PersistenceStatusActive": "Heartbeat Keep Days",
						"PersistenceStatusActiveTip": "Days. Range: 3-90. Suggest: 7."
					}
				},
				"notice": {
					"NoticeLanguage": "Notice Language",
					"NoticeLanguageTip": "Language for system notices.",
					"SmsTitle": "SMS Config",
					"SmsTip": "SMS number",
					"EmailTitle": "Email Config",
					"EmailTip": "Notification email",
					"noticeRule": "Notification Config",
					"webNotice": "Web Notice",
					"phoneNotice": "SMS",
					"emailNotice": "Email",
					"userChange": "Account Change",
					"deviceStatus": "Device Status"
				},
				"hly": {
					"title": "Cloud Config",
					"CountUploadImages": "Max Images",
					"CountUploadImagesTip": "Default 50, Max 100",
					"PressText": "Watermark",
					"PressTextTip": "Max 10 chars",
					"ProjectScanFrequency": "Scan Freq",
					"ProjectScanFrequencyTip": "1-3600s, Default 60s",
					"DeviceHeartBeatFrequency": "Heartbeat",
					"DeviceHeartBeatFrequencyTip": "Default 300s",
					"DeviceActiveAttemption": "Heartbeat Fail Threshold",
					"DeviceActiveAttemptionTip": "Default 10 times",
					"PersistenceStatusActive": "Heartbeat Keep Days",
					"PersistenceStatusActiveTip": "3-90 days, Suggest 7",
					"PersistencePivHistoryElectricity": "PV Data Keep Days",
					"PersistencePivHistoryElectricityTip": "1-365 days, Default 30"
				},
				"ems": {
					"title": "Station End",
					"EmsId": "EMS ID",
					"EmsIdTip": "Unique ID. Range: 1000-9999.",
					"EmsSecurityLevel": "Security Level",
					"EmsSecurityLevelTip": "0-Standard, 1-Enhanced, 2-High. Default: 0.",
					"EmsRunMode": "Run Mode",
					"EmsRunModeTip": "0-Auto, 1-Manual. Default: 0.",
					"EmsEmergencyStopMode": "Emergency Stop",
					"EmsEmergencyStopModeTip": "0-HV Break, 1-PCS Stop. Default: 0.",
					"EmsReadRegisterAttemption": "Read Retry",
					"EmsReadRegisterAttemptionTip": "Times. Range: 0-100. Default: 3.",
					"EmsWriteRegisterAttemption": "Write Retry",
					"EmsWriteRegisterAttemptionTip": "Times. Range: 0-100. Default: 2.",
					"EmsValidateChargeAttemption": "Charge Verify Retry",
					"EmsValidateChargeAttemptionTip": "Times. Range: 0-100. Default: 3.",
					"EmsValidateChargeDuration": "Charge Verify Freq",
					"EmsValidateChargeDurationTip": "ms. Range: 1000-60000. Default: 3000.",
					"EmsValidateDischargeAttemption": "Discharge Verify Retry",
					"EmsValidateDischargeAttemptionTip": "Times. Range: 0-100. Default: 3.",
					"EmsValidateDischargeDuration": "Discharge Adjust Freq",
					"EmsValidateDischargeDurationTip": "ms. Range: 1000-60000. Default: 1000.",
					"EmsAdjustDischargingPowerFrequency": "Discharge Adjust Freq",
					"EmsAdjustDischargingPowerFrequencyTip": "ms. Range: 1000-60000. Default: 1000.",
					"EmsMinIntervalBetweenChargeAndDischarge": "C/D Switch Interval",
					"EmsMinIntervalBetweenChargeAndDischargeTip": "Seconds. Range: 300-1800. Default: 600.",
					"EmsChargingPowerDistributionType": "Charge Pwr Distribution",
					"EmsChargingPowerDistributionTypeTip": "0-Avg, 1-Preemptive. Default: 0.",
					"EmsReDistributeDischargingPowerBetweenAmus": "Re-distribute Discharge Pwr",
					"EmsReDistributeDischargingPowerBetweenAmusTip": "0-No, 1-Yes. Default: 1.",
					"EmsPreservedActivePowerDischarge": "Grid Reserved Pwr",
					"EmsPreservedActivePowerDischargeTip": "Watt. Default: 0.",
					"EmsDischargingPowerDistributionType": "Discharge Pwr Distribution",
					"EmsDischargingPowerDistributionTypeTip": "0-Avg, 1-Preemptive. Default: 0.",
					"EmsAmuMatchType": "AMU Match Mode",
					"EmsAmuMatchTypeTip": "0-All, 1-Precise. Default: 0.",
					"EmsLogLevel": "Log Level",
					"EmsLogLevelTip": "0-Basic, 1-Enhanced, 2-Detailed. Default: 1.",
					"EmsRuntimeStrictMode": "Runtime Strict Mode",
					"EmsRuntimeStrictModeTip": "0-Normal, 1-Strict. Default: 1.",
					"EmsHistoryRuntimeFrequency": "Runtime Log Freq",
					"EmsHistoryRuntimeFrequencyTip": "Seconds. Range: 30-300. Default: 60.",
					"EmsHistoryKeyFrequency": "Key Param Log Freq",
					"EmsHistoryKeyFrequencyTip": "Seconds. Range: 1-300. Default: 30.",
					
					
					EmsHistoryKeyFrequency:"设备关键参数的日志持久化频率",
					EmsHistoryKeyFrequencyTip:"设备关键运行参数日志的持久化频率，单位：秒。允许的数值范围：1 - 300，默认值：30。",
					
					EmsPublishSkrtToHly:"同步设备关键参数至云端",
					EmsPublishSkrtToHlyTip:"按照设定的频率，向云端发布场站端的设备关键参数。允许的数值范围：0 - 1，默认值：0。",
					
					EmsAmuMaxDemandRelatedDays:"最大需量的参考天数",
					EmsAmuMaxDemandRelatedDaysTip:"从近期数据中，取辅助计量单元的有功功率最大值，作为其上月最大需量。允许范围：1 - 180，默认值：30天。",
					
					EmsAmuMaxDemandDuration:"最大需量的有效时长",
					EmsAmuMaxDemandDurationTip:"最大需量时在缓存中的存活时长,允许的数值范围：5 - 86400，默认值：600秒。"
				}
			}
		},
		"emsPolicy": {
			"deviceList": "ESS Devices",
			"policyChart": "Policy Example",
			"demoPolicy": "Example Data",
			"editPolicy": "Edit Policy",
			"isSendPolicy": "Send control policy?",
			"sendPolicy": "Send Policy",
			importPolicy:"Import Policy",
			"removePolicy": "Remove Unit",
			"addPolicy": "Add Unit",
			"savePolicy": "Save Policy",
			"searchTip": "Filter keyword",
			"charge": "Charge",
			"discharge": "Discharge",
			"standby": "Standby",
			"policy": {
				"policyName": "Policy Name",
				"startTime": "Start Time",
				"endTime": "End Time",
				"opType": "Action",
				"maxActivePower": "Max Power",
				"period": "Time Range",
				"max": "Unlimited",
				"force": {
					"title": "Force Start",
					"falseText": "Hold",
					"trueText": "Force"
				},
				"enable": {
					"title": "Enabled",
					"falseText": "No",
					"trueText": "Yes",
					"enableText": "Enabled",
					"unEnable": "Disabled"
				},
				"maxSoc": "SOC Limit"
			},
			"policyUnit": {
				"title": "Policy Unit",
				"opType": "Action Type",
				"timePlaceholder": "Select Time"
			}
		},
		"emsWeb": {
			"projectWeb": "Project Config",
			"project": "Project"
		},
		"historyAnalysis": {
			"searchTip": "Filter keyword",
			"dayData": "Summary",
			"hourData": "Hourly",
			"monthData": "Monthly",
			"timeManage": "Manage Periods",
			"emptyTip": "No Data",
			"positiveActiveEnergy": "Forward Incr",
			"NegativeActiveEnergy": "Reverse Incr",
			"timePeriod": "Period",
			"time": "Time",
			"total": "Total",
			"timeManageForm": {
				"title": "Period Config",
				"name": "Name",
				"range": "Range",
				"addTime": "Add Period",
				"saveTime": "Save Period"
			}
		},
		"projectEvent": {
			"eventTime": "Event Time",
			"eventLevelPlaceholder": "Select Level",
			"sreachKey": "Enter keyword",
			"eventNo": "Event No",
			"createTime": "Created",
			"eventLevel": "Risk Level",
			"eventTable": {
				"deviceName": "Device Name",
				"deviceNo": "Device Code",
				"typeName": "Type",
				"deviceGroupName": "Group",
				"eventDetail": "Details",
				"timeOld": "Prev Time",
				"timeNew": "Current Time",
				"valueOld": "Prev Value",
				"valueNew": "Current Value",
				"eventDescription": "Description",
				"solution": "Solution",
				"riskLevelOp": {
					"info": "Info",
					"badly": "Serious",
					"danger": "Danger"
				}
			}
		},
		"menu": {
			"mainview": "Home",
			"setSystem": "System Config",
			"setPermission": "Permission Config",
			"systemProject": "Projects",
			"systemRole": "Roles",
			"systemUser": "Users",
			"systemPermissions": "Role Permissions",
			"systemSettings": "System Params",
			"setProject": "Project Config",
			"userRole": "Roles & Members",
			"projectRole": "Project Roles",
			"projectMember": "Project Members",
			"projectPermissions": "Project Permissions",
			"message": "Message Config",
			"setProjectParameter": "Project Config",
			"deviceManage": "Device Mgmt",
			"baseDada": "Base Data",
			"deviceType": "Device Types",
			"deviceFactory": "Manufacturers",
			"deviceModel": "Models",
			stationRunStatus:"Station Run Status",
			
			
			
			emsTools:"ems Tools",
			editEmsSystem:"edit Ems System",
			editStationKeyRuntime:"edit Station Key Runtime",
			editStationEvent:"edit Station Event",
			
			hem:"家庭电站",
			hemCusomerType:"客户类型",
			hemCusomer:"客户列表",
			hemSuiteModel:"设备套件型号",
			hemSuite:"设备套件",
			hemHistoryStation:"场站日志",
			
			vpp:"虚拟电厂",
			energyMarket:"交易大厅",
			energyInformation:"消息报送",
			orderInformation:"合约信息",
			customerServer:"客户服务",
			
			
			editEmsSystem:"edit Ems System",
			"projectMonitor": "Project Monitor",
			"subarea": "Areas",
			"emsPolicy": "Station Policy",
			"data": "Statistics",
			"historyAnalysis": "Efficiency Analysis",
			"checkLog": "Log Audit",
			"projecteEvent": "Project Events",
			"log": "Project Logs",
			"emsWeb": "Station Config",
			"mapView": "Smart Energy"
		},
		"checkParameter": {
			"edit": {
				"deviceId": "Device ID required",
				"deviceIdLength": "Device ID must be 12 chars",
				"deviceName": "Name required",
				"deviceNameLength": "Name min 2 chars",
				"deviceNo": "Code required",
				"deviceNolength": "Code min 3 chars",
				"deviceType": "Type required",
				"deviceModel": "Model required",
				"deviceGroup": "Group required",
				"protocolVersion": "Protocol Ver required",
				"udpPort": "Service Port required",
				"dtuDeviceId": "Uplink Relay required",
				"modbusSlaveNo": "Slave No required",
				"potentialTransformer": "Voltage Ratio required",
				"currentTransformer": "Current Ratio required",
				"serverAddress": "Comm Address required",
				"serverPort": "Service Port required",
				"serialPortName": "Serial Port required",
				"baudRate": "Baud Rate required",
				"dataBit": "Data Bits required",
				"stopBit": "Stop Bits required",
				"parityCheck": "Parity required",
				"intervalMonitor": "Monitor Cycle required",
				"frameCheck": "Frame Check required",
				"broadcastEnable": "Listen Broadcast required",
				"comProtocol": "Comm Protocol required",
				"coa": "Common Addr required",
				"interrogationType": "Interrogation Type required",
				"useMultiThreads": "Thread Mode required",
				"dischargeAmuDeviceId": "Discharge AMU required",
				"chargeAmuDeviceId": "Charge AMU required",
				"bcpDeviceId": "Battery Cabin required",
				"bcpstackDeviceId": "Battery Stack required"
			}
		}
	}

}